// import { BehaviorSubject } from "rxjs/BehaviorSubject";
// import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import Storage from "./storage.service";
import Flow from "./flow.service";
import User from "./user.service";

import Helpers from "../helpers/shared.helper";
// import Plans from "./plans.service";
import FirebaseAnalytics from "./analytics.service";
import Settings from "./settings.service";

var Activation = {};

// var module_state = {
// 	"1": "Enabled",
// 	"2": "InProgress",
// 	"3": "Completed",
// 	"4": "Disabled"
// }
//
//Activation.Init()

Activation.start = () => {
	const flags = Storage.get("flags");
	if(flags.PaymentPending) return
	Activation.activate()
		.then((response) => {
			if(response.data) {
				User.fetchFlowStatus();
			} else {
				Storage.set("ActivationFailedErr", true, true);
			}
			// if (response.data['smdp_url']) {
			// 	Storage.set('smdp_url', response.data['smdp_url'], true)
			// }
		})
		.catch((error) => { Storage.set("ActivationFailedErr", true, true); });
};

Activation.checkModule = () => {


	let key = Storage.get("module", true);


	let modules_by_name = Storage.get("activation_modules_by_name");

	let mod = null;

	if (modules_by_name && modules_by_name[key]) {
		mod = modules_by_name[key];
	}


	let not_fulfilled_found = false;

	if (mod) {

		let fulfilmentsLength = mod.Fulfilments.length;
		let fulfilmentsAllStep = true
		for (let i = 0; i < fulfilmentsLength; i++) {
			let fulfilment = mod.Fulfilments[i];

			if (fulfilment.Key === "Absher") {
				if (fulfilment.ModuleState !== 3) {
					not_fulfilled_found = true;
					fulfilmentsAllStep = false;

					break;
				}
			}
			else {
				if (!fulfilment.IsFulfilled) {
					not_fulfilled_found = true;
					fulfilmentsAllStep = false;
					break;
				}
			}
			// if (fulfilment.ModuleState !== 3) {
			// 	not_fulfilled_found = true;
			// 	fulfilmentsAllStep = false;
			// 	break;
			// }
		}

		if (fulfilmentsAllStep) {
			Activation.start();
		}
		else {
			for (let i = 0; i < fulfilmentsLength; i++) {
				let fulfilment = mod.Fulfilments[i];
				if (fulfilment.Key === 'Absher') {
					if (fulfilment.ModuleState !== 3) {
						// go to absher

						Storage.clear("absher_fulfilled");
						continue;
					}
				}
				switch (fulfilment.Key) {
					case "Payment":
						// go to payment
						Storage.set("web_payment_required", true, true);
						// Flow.goTo("pay");
						break;

					case "SIMDelivery":
						// go to Delivery
						Helpers.log("go to Delivery");
						Storage.set("web_delivery_required", true, true);
						// Flow.goTo();

						break;
					case "SIM":
						// call activation api
						// go to options page
						// Storage.clear("web_delivery_required");
						// Storage.clear("module");
						Storage.clear("selected_module");
						// Activation.start();
						break;
					default:
				}

			}
			if (not_fulfilled_found && !Storage.get("back_to_module")) {
				Flow.goTo();
			}
		}
	}
};

Activation.fetchModules = (include_customer_data = true) => {
	let config = {
		method: "get",
		url: "/activation/modules?include_customer_data=" + include_customer_data,
		headers: {
			"cache-control": "no-cache"
		}
	};
	return HTTP(config);
};

Activation.setActivationModule = (key) => {
	let modules_by_name = Storage.get("activation_modules_by_name");
	let mod = null;
	if (key === "has_sim") {
		mod = modules_by_name.full_digital_activation;
		Storage.clear("web_delivery_required");
	}
	if (key === "has_esim") {
		mod = modules_by_name.full_digital_activation;
		Storage.clear("web_delivery_required");
	}
	if (key === "deliver_sim") {
		mod = modules_by_name.home_delivery_self_activation;
	}
	if (key === "in_store_activation") {
		Storage.set("web_store_pickup", true, true);
		mod = modules_by_name.store_pickup_activation;
		Storage.clear("web_delivery_required");
	}

	Storage.clear("web_payment_required");
	Storage.set("module", mod.ProcessName, true);
	Activation.checkModule();
	// Storage.set("chosen_module", mod["ProcessName"], true);
};

Activation.activateSim = (form) => {
	Helpers.log("form==", form);

	if (form["sim_availability"]) {
		let val = form["sim_availability"]["value"];
		let data = null;

		if (!val) {
			val = Storage.get("selected_module", true);
		}

		if (val === "has_esim") {
			data = {
				imsi: "",
				is_esim: true,
			};
			Activation.postSimInfo(data)
				.then((res) => {
					let firebase_param = {
						method: "esim"
					}
					Storage.set("isSimSelected", true, true);
					FirebaseAnalytics.sim_scanned(firebase_param);
					//fetch new plans and update summary for esimDouble data calculation
					// Plans.getPlans("Available", true).then(response => {
					// 	Plans.getPlans("Predefined", true).then(response => { }).catch(err => { })
					// }).catch(err => { });
					Helpers.log("res=", res);
					Activation.setActivationModule(val);

					Activation.getModules()
						.then((response) => {
							User.fetchFlowStatus();
						})
						.catch((error) => { });
					// then Activation.activate();
				})
				.catch((err) => {
					Helpers.log("err=", err);
				});
		} else if (val === "has_sim") {
			Storage.set("physicalSIMError", true);
			Storage.set("physicalSIMLoader", true);
			data = {
				imsi: form.sim_number.value,
				is_esim: false,
			};
			Activation.postSimInfo(data)
				.then((res) => {
					Storage.clear("physicalSIMError");
					Storage.clear("physicalSIMLoader");
					let firebase_param = {
						method: "kitCode"
					}
					Storage.set("isSimSelected", true, true);
					FirebaseAnalytics.sim_scanned(firebase_param);
					Helpers.log("res=", res);
					Activation.setActivationModule(val);
					Activation.getModules()
						.then((response) => {
							User.fetchFlowStatus();
						})
						.catch((error) => { });
					// then Activation.activate();
				})
				.catch((err) => {
					Storage.clear("physicalSIMError");
					Storage.clear("physicalSIMLoader");
				});
		} else {
			Activation.setActivationModule(val);
		}
	}
};

Activation.init = () => {
	if (Storage.get("module", true)) {
		Activation.getModules().then(res => {
			User.fetchFlowStatus();
		}).catch(error => { });
	}
}

Activation.getModules = () => {
    // Storage.set("moduleAPIError", true);
	let f = Storage.getOrfetch(
		"activation_modules",
		Activation.fetchModules,
		true
	);
	f
		.then((response) => {
			if (response) {
				if (response.data) {

					let old = Storage.get("activation_modules");

					if (!old || JSON.stringify(response.data) !== JSON.stringify(old)) {
						// Helpers.log("activation_modules=", response.data);

						let modules = response.data;

						for (let index in modules) {
							for (let hindex in modules[index]["Fulfilments"]) {
								if (modules[index]["Fulfilments"][hindex]["Key"] === "Absher") {
									let moduleState = modules[index]["Fulfilments"][hindex]["ModuleState"]
									switch (moduleState) {
										case 3:
											Storage.set("absher_fulfilled", true);
											break;
										case 5:
											Storage.clear("absher_fulfilled");
											break;
										default:
									}
								}
							}
						}

						let modules_by_name = Helpers.arrayToObject(modules, "ProcessName");
						Storage.set("activation_modules_by_name", modules_by_name);
						Storage.set("activation_modules", modules);

					}

				}
			}
			// Storage.clear("moduleAPIError");
		})
		.catch(() => { 
			// Storage.clear("moduleAPIError");
			// window.location.href = "/join"
		});

	return f;
};

Activation.getNewAbsherToken = () => {
	let business = JSON.parse(Storage.get("business", true));
	let config = {
		method: "get",
		url: business[Settings?.nafath_login_url || "nafath_login_url"],
	};
	return HTTP(config);
};

Activation.getAbsherToken = () => {
	let config = {
		method: "get",
		url: "/activation/absher_token",
		data: {
            category: "1"
        },
	};
	return HTTP(config);
};

Activation.activate = () => {
	Storage.set("activationError", true, true);
	let config = {
		method: "post",
		url: "/activation/activate",
	};
	return HTTP(config);
};

Activation.postAbsherToken = (data) => {
	// example creation_date = 2019-05-22T12:26:19Z

	// let data = {
	// 	token: "",
	// 	creation_date: ""
	// };
	let config = {
		method: "post",
		url: "/activation/absher_token",
		data: data,
	};
	return HTTP(config);

	// Sample response
	// {
	// 	"token": null,
	// 	"expiry_date": null
	// }
};

Activation.getSimInfo = () => {
	let config = {
		method: "get",
		url: "/activation/sim",
	};
	return HTTP(config);
	// Sample response
	// 	{
	//   "is_esim": false,
	//   "imsi": null
	// }
};

Activation.postSimInfo = (data) => {
	// let data = {
	// 	is_esim: is_esim,
	// 	imsi: imsi
	// };
	// let data = {
	// 	is_esim: true,
	// 	imsi: ""
	// };
	let config = {
		method: "post",
		url: "/activation/sim",
		data: data,
	};
	return HTTP(config);
};

Activation.activateAtStore = (
	skip_cc = true,
	request_delivery = true,
	redirect = false
) => {
	User.updateFlowStatus("IsCreditCardSkipped", skip_cc);

	const flags = Storage.get("flags");
	Storage.set("chose_delivery", request_delivery, true);
	flags.IsCreditCardSkipped = skip_cc;
	flags.chose_payment_option = true;
	Storage.set("flags", flags);
	if (redirect) {
		Flow.next();
	}
};

export default Activation;
